<div class="preview-container" [ngClass]="{'panel-hidden': !isPanelVisible, 'preview-text-container' : type === 'text'}">
    <ng-container *ngIf="!spinner">

    
   <app-preview-error
    class="preview-file"
    *ngIf="!initialized && errcode"
    [item]="item"
    [errcode]="errcode"
    [syncId]="locId"
    ></app-preview-error>

    <app-preview-error
    class="preview-file"
    *ngIf="initialized && errcode"
    [item]="item"
    [errcode]="errcode"
    [syncId]="locId"
    ></app-preview-error>
    
    <app-preview-image
    #previewImage
    class="preview-file"
    *ngIf="type === 'image' && imageListReady"
    [canShowImageNav]="!isViewInDialog"
    [item]="item"
    [list]="imageList"
    [syncId]="locId"
    (getCurrentFile)="getCurrentFile($event)"
    ></app-preview-image>

    <app-preview-default
    class="preview-file"
    *ngIf="type === 'default' && initialized"
    [item]="item"
    [upsell]="upsell"
    [notice]="notice"
    ></app-preview-default>

    <app-preview-doc
    class="preview-file"
    *ngIf="type === 'doc' && initialized"
    [item]="item"
    (stateChange)="onStateChange($event)"
    ></app-preview-doc>

    <app-preview-text
    class="preview-file"
    *ngIf="type === 'text' && initialized"
    [item]="item"
    ></app-preview-text>

    <app-preview-wopi
    class="preview-file"
    *ngIf="
    (type === 'office' || type === 'officefse' || type === 'officefsv') &&
    initialized
    "
    [item]="item"
    (stateChange)="onStateChange($event)"
    ></app-preview-wopi>

    <app-preview-video 
    class="preview-file"
    *ngIf="type === 'video' && initialized && user?.is_pro" 
    [videoUrl]="url"
    [mimeType]="mimeType"
    [item]="item"
    ></app-preview-video>

    <app-preview-audio 
    class="preview-file"
    *ngIf="type === 'audio' && initialized && user?.is_pro" 
    [audioUrl]="url"
    [mimeType]="mimeType"
    [item]="item"
></app-preview-audio>
    <!-- file info panel -->
    <div class="info-panel" *ngIf="isPanelVisible">
        <div class="info-panel-heading">
           <sync-section-header 
           header="File Info" 
           level="h6"
           [showActions]="true" 
           [showIconButton]="true" 
           [leadAdornmentConfig]="{
           type: 'icon',
           enabled: true,
           size: 'large',
           iconName: 'info'
           }"
           [iconButtonConfig]="{size: 'large', iconName: 'close', onClick: closeSidePanel}"></sync-section-header>
        </div>
        <div class="info-panel-body">
           <ng-container>
              <sync-list [ListItems]="infoListItems"></sync-list>
           </ng-container>
        </div>
     </div>
   </ng-container>
</div>
  
 <ng-template #dialogTitle>
    <div class="info-dialog-title">
       <sync-icon name="info" class="title-icon"></sync-icon>
       <span class="h6">File Info</span>
    </div>
 </ng-template>
  <sync-dialog 
     *ngIf="isSmallScreen" 
     [config]="{
     titleTemplate: dialogTitle,
     isClosable: true}" 
     [open]="showInfoDialog" 
     [isFullScreen]="true" 
     [onClose]="closeInfoDialog">
         <div class="file-details">
             <sync-list [ListItems]="infoListItems"></sync-list>
         </div>
  </sync-dialog>
 
  <app-dialog-rename
     *ngIf="item && !isViewInDialog"
     [(isOpen)]="showRenameDialog"
     [Item]="item"
     (renameSuccess)="onRenameSuccess($event)"
 ></app-dialog-rename>
 
 <app-move-dialog
    *ngIf="showMoveDialog"
    [(showMoveDialog)]="showMoveDialog"
    [selectedRows]="[this.item]"
    [actionMoveOrCopy]="this.WebpathActionType.MOVE"
 ></app-move-dialog>
 
 <app-move-dialog
    *ngIf="showCopyDialog"
    [(showMoveDialog)]="showCopyDialog"
    [selectedRows]="[this.item]"
    [actionMoveOrCopy]="this.WebpathActionType.COPY"
    [defaultTab]="isVault ? 'Vault' : 'Files'"
 ></app-move-dialog>
 
 <app-dialog-delete
    *ngIf="showDeleteDialog"
    [(showDialog)]="showDeleteDialog"
    [selectedItems]="[this.item]"
    (deleteSuccess)="onDeleteSuccess()"
 ></app-dialog-delete>
 
 
 <ng-template #dialoglinkcontent>
     <app-dialog-link [item]="item" [onLinkMutate]="onLinkMutate"></app-dialog-link>
 </ng-template>